import React from 'react';
import cx from 'classnames';

import T from 'Utilities/texts';

import { Content } from 'LegacySBCRA/Content/Content';
import { LogoAffiliate } from 'Storybook/components/local/LogoAffiliate/LogoAffiliate';
import { AffiliateType } from 'Storybook/components/local/LogoAffiliate/LogoAffiliate.helpers';

import styles from './AffiliateHeader.scss';

const AffiliateHeader = ({
  affiliate,
}: {affiliate: AffiliateType}) => (
  <Content
    className={styles.component}
    wrapper={{ className: styles.wrapper }}
  >
    <div>{T.translate('components.affiliateHeader.title')}</div>
    <LogoAffiliate
      affiliate={affiliate}
      className={cx(styles.affiliateLogo, styles[affiliate])}
    />
  </Content>
);

export default AffiliateHeader;
